/**
 * Created by caterina on 23-05-17.
 */
import {TubestFormComponent} from 'app/steel-profile/steel-profile-forms/tubest-form/tubest-form.component';

import {TubestCFormComponent} from './steel-profile-forms/tubest-c-form/tubest-c-form.component';
import {ZTubestFormComponent} from './steel-profile-forms/z-tubest-form/z-tubest-form.component';
import {SquaredProfileFormComponent} from './steel-profile-forms/squared-profile-form/squared-profile-form.component';
import {RectangularProfileFormComponent} from './steel-profile-forms/rectangular-profile-form/rectangular-profile-form.component';
import {CintacPurlinFormComponent} from './steel-profile-forms/cintac-purlin-form/cintac-purlin-form.component';

import {FrameProfileFormComponent} from './steel-profile-forms/frame-profile-form/frame-profile-form.component';
import {PurlinProfileFormComponent} from './steel-profile-forms/purlin-profile-form/purlin-profile-form.component';
import {EaveStrutProfileFormComponent} from './steel-profile-forms/eave-strut-profile-form/eave-strut-profile-form.component';


// TODO: Use id of table ProfileType
export const TUBEST_PROFILE = 1
export const TUBEST_C_PROFILE = 2
export const Z_TUBEST_PURLIN = 3
export const SQUARED_PROFILE = 4
export const RECTANGULAR_PROFILE = 5
export const CINTAC_PURLIN_PROFILE = 6
//
// const SteelProfileFormComponents = {
//     0: TubestFormComponent,
//     1: TubestCFormComponent,
//     2: ZTubestFormComponent,
//     3: SquaredProfileFormComponent,
//     4: RectangularProfileFormComponent,
//     5: CintacPurlinFormComponent
// };
//
// const SteelProfileNameList = [
//     {name: 'Perfil Tubest', value: TUBEST_PROFILE},
//     {name: 'Perfil Tubest C', value: TUBEST_C_PROFILE},
//     {name: 'Costanera Z Tubest', value: Z_TUBEST_PURLIN},
//     {name: 'Perfil Cuadrado ATSM A500 ', value: SQUARED_PROFILE},
//     {name: 'Perfil Rectangular ATSM A500 ', value: RECTANGULAR_PROFILE},
//     {name: 'Costanera Cintac ET-11/MA-7-2', value: CINTAC_PURLIN_PROFILE},
// ];

const ProfileFamilyList = [
  {name: 'Perfil de Marco', value: 'FrameProfile'},
  {name: 'Perfil de Costanera', value: 'PurlinProfile'},
  {name: 'Perfil de Puntal/Riostra', value: 'EaveStrutProfile'}
];

export class SteelProfile {
    id: number;
    // type: number;
    name: string;
    type_name: string;
    weight?: number;
    sap_code?: string;
    profile_type: number;


    // static getProfileByType(type: number) {
    //     switch (type) {
    //         case TUBEST_PROFILE:
    //             return new TubestProfile();
    //         case TUBEST_C_PROFILE:
    //             return new TubestCProfile();
    //         case Z_TUBEST_PURLIN:
    //             return new ZTubestPurlin();
    //         case SQUARED_PROFILE:
    //             return new SquaredProfile();
    //         case RECTANGULAR_PROFILE:
    //             return new RectangularProfile();
    //         case CINTAC_PURLIN_PROFILE:
    //             return new CintacPurlinProfile();
    //     }
    // }

    static getProfileByFamily(family: string){
      if(family == "FrameProfile"){
        return new FrameProfile();
      } else if(family == "PurlinProfile"){
        return new PurlinProfile();
      } else if(family == "EaveStrutProfile"){
        return new EaveStrutProfile();
      }
    }

    // static getNames() {
    //     return SteelProfileNameList;
    // }

    // static getSteelProfileFormComponent(type: number) {
    //     return SteelProfileFormComponents[type];
    // }

    static getSteelProfileFormComponent(family: string): any {
      if(family == "FrameProfile") return FrameProfileFormComponent;
      else if(family == "PurlinProfile") return PurlinProfileFormComponent;
      else if(family == "EaveStrutProfile") return EaveStrutProfileFormComponent;
    }

    constructor() {
        this.id = -1;
        // this.type = -1;
        this.profile_type = -1;
        this.name = '';
    }
}

export class ProfileType {
  id: number;
  name: string;
  family: string;

  constructor() {
    this.id = -1;
    this.name = '';
    this.family = '';
  }

  static getFamilies() {
    return ProfileFamilyList;
  }

}

export class FrameProfile extends SteelProfile {
  profile_type: number;
  B: number;
  H: number;
  eo: number;
  es: number;
  Wy: number;
  Aef: number;
  Ix: number;
  Q: number;
  Lc: number;
  Iy: number;
  A: number;
  ry: number;
  Mc: number;
  Wx: number;
  rx: number;

  constructor() {
      super();
      this.B = null;
      this.H = null;
      this.eo = null;
      this.es = null;
      this.Wy = null;
      this.Aef = null;
      this.Ix = null;
      this.Q = null;
      this.Lc = null;
      this.Iy = null;
      this.A = null;
      this.ry = null;
      this.Mc = null;
      this.Wx = null;
      this.rx = null;
  }
}

export class TubestProfile extends SteelProfile {
    B: number;
    H: number;
    eo: number;
    es: number;
    Wy: number;
    Aef: number;
    Ix: number;
    Q: number;
    Lc: number;
    Iy: number;
    A: number;
    ry: number;
    Mc: number;
    Wx: number;
    rx: number;

    constructor() {
        super();
        // this.type = TUBEST_PROFILE;
        this.B = null;
        this.H = null;
        this.eo = null;
        this.es = null;
        this.Wy = null;
        this.Aef = null;
        this.Ix = null;
        this.Q = null;
        this.Lc = null;
        this.Iy = null;
        this.A = null;
        this.ry = null;
        this.Mc = null;
        this.Wx = null;
        this.rx = null;
    }
}


export class TubestCProfile extends SteelProfile {
    B: number;
    H: number;
    eo: number;
    es: number;
    Wy: number;
    Aef: number;
    Ix: number;
    Q: number;
    Lc: number;
    Iy: number;
    A: number;
    ry: number;
    Mc: number;
    Wx: number;
    rx: number;

    constructor() {
        super();
        // this.type = TUBEST_C_PROFILE;
        this.B = null;
        this.H = null;
        this.eo = null;
        this.es = null;
        this.Wy = null;
        this.Aef = null;
        this.Ix = null;
        this.Q = null;
        this.Lc = null;
        this.Iy = null;
        this.A = null;
        this.ry = null;
        this.Mc = null;
        this.Wx = null;
        this.rx = null;
    }
}

export class PurlinProfile extends SteelProfile {
    profile_type: number;
    A: number;
    B: number;
    C: number;
    e: number;
    // l: number;
    qt_sa_scr_5: number;
    qt_sa_scr_6: number;
    qt_sa_scr_7: number;
    qt_sa_scr_8: number;
    qt_sa_scr_9: number;
    qt_sa_scr_10: number;
    qt_sa_ccr_5: number;
    qt_sa_ccr_6: number;
    qt_sa_ccr_7: number;
    qt_sa_ccr_8: number;
    qt_sa_ccr_9: number;
    qt_sa_ccr_10: number;
    qt_tr_scr_5: number;
    qt_tr_scr_6: number;
    qt_tr_scr_7: number;
    qt_tr_scr_8: number;
    qt_tr_scr_9: number;
    qt_tr_scr_10: number;
    qt_tr_ccr_5: number;
    qt_tr_ccr_6: number;
    qt_tr_ccr_7: number;
    qt_tr_ccr_8: number;
    qt_tr_ccr_9: number;
    qt_tr_ccr_10: number;
    qt_ex_scr_5: number;
    qt_ex_scr_6: number;
    qt_ex_scr_7: number;
    qt_ex_scr_8: number;
    qt_ex_scr_9: number;
    qt_ex_scr_10: number;
    qt_ex_ccr_5: number;
    qt_ex_ccr_6: number;
    qt_ex_ccr_7: number;
    qt_ex_ccr_8: number;
    qt_ex_ccr_9: number;
    qt_ex_ccr_10: number;
    qd_sa_5: number;
    qd_sa_6: number;
    qd_sa_7: number;
    qd_sa_8: number;
    qd_sa_9: number;
    qd_sa_10: number;
    qd_tr_5: number;
    qd_tr_6: number;
    qd_tr_7: number;
    qd_tr_8: number;
    qd_tr_9: number;
    qd_tr_10: number;
    qd_ex_5: number;
    qd_ex_6: number;
    qd_ex_7: number;
    qd_ex_8: number;
    qd_ex_9: number;
    qd_ex_10: number;

    constructor() {
        super();
        this.A = null;
        this.B = null;
        this.C = null;
        this.e = null;
        // this.l = null;
        this.qt_sa_scr_5 = null;
        this.qt_sa_scr_6 = null;
        this.qt_sa_scr_7 = null;
        this.qt_sa_scr_8 = null;
        this.qt_sa_scr_9 = null;
        this.qt_sa_scr_10 = null;
        this.qt_sa_ccr_5 = null;
        this.qt_sa_ccr_6 = null;
        this.qt_sa_ccr_7 = null;
        this.qt_sa_ccr_8 = null;
        this.qt_sa_ccr_9 = null;
        this.qt_sa_ccr_10 = null;
        this.qt_tr_scr_5 = null;
        this.qt_tr_scr_6 = null;
        this.qt_tr_scr_7 = null;
        this.qt_tr_scr_8 = null;
        this.qt_tr_scr_9 = null;
        this.qt_tr_scr_10 = null;
        this.qt_tr_ccr_5 = null;
        this.qt_tr_ccr_6 = null;
        this.qt_tr_ccr_7 = null;
        this.qt_tr_ccr_8 = null;
        this.qt_tr_ccr_9 = null;
        this.qt_tr_ccr_10 = null;
        this.qt_ex_scr_5 = null;
        this.qt_ex_scr_6 = null;
        this.qt_ex_scr_7 = null;
        this.qt_ex_scr_8 = null;
        this.qt_ex_scr_9 = null;
        this.qt_ex_scr_10 = null;
        this.qt_ex_ccr_5 = null;
        this.qt_ex_ccr_6 = null;
        this.qt_ex_ccr_7 = null;
        this.qt_ex_ccr_8 = null;
        this.qt_ex_ccr_9 = null;
        this.qt_ex_ccr_10 = null;
        this.qd_sa_5 = null;
        this.qd_sa_6 = null;
        this.qd_sa_7 = null;
        this.qd_sa_8 = null;
        this.qd_sa_9 = null;
        this.qd_sa_10 = null;
        this.qd_tr_5 = null;
        this.qd_tr_6 = null;
        this.qd_tr_7 = null;
        this.qd_tr_8 = null;
        this.qd_tr_9 = null;
        this.qd_tr_10 = null;
        this.qd_ex_5 = null;
        this.qd_ex_6 = null;
        this.qd_ex_7 = null;
        this.qd_ex_8 = null;
        this.qd_ex_9 = null;
        this.qd_ex_10 = null;
    }
}


export class ZTubestPurlin extends SteelProfile {
    A: number;
    B: number;
    C: number;
    e: number;
    l: number;
    qt_sa_scr_5: number;
    qt_sa_scr_6: number;
    qt_sa_scr_7: number;
    qt_sa_scr_8: number;
    qt_sa_scr_9: number;
    qt_sa_scr_10: number;
    qt_sa_ccr_5: number;
    qt_sa_ccr_6: number;
    qt_sa_ccr_7: number;
    qt_sa_ccr_8: number;
    qt_sa_ccr_9: number;
    qt_sa_ccr_10: number;
    qt_tr_scr_5: number;
    qt_tr_scr_6: number;
    qt_tr_scr_7: number;
    qt_tr_scr_8: number;
    qt_tr_scr_9: number;
    qt_tr_scr_10: number;
    qt_tr_ccr_5: number;
    qt_tr_ccr_6: number;
    qt_tr_ccr_7: number;
    qt_tr_ccr_8: number;
    qt_tr_ccr_9: number;
    qt_tr_ccr_10: number;
    qt_ex_scr_5: number;
    qt_ex_scr_6: number;
    qt_ex_scr_7: number;
    qt_ex_scr_8: number;
    qt_ex_scr_9: number;
    qt_ex_scr_10: number;
    qt_ex_ccr_5: number;
    qt_ex_ccr_6: number;
    qt_ex_ccr_7: number;
    qt_ex_ccr_8: number;
    qt_ex_ccr_9: number;
    qt_ex_ccr_10: number;
    qd_sa_5: number;
    qd_sa_6: number;
    qd_sa_7: number;
    qd_sa_8: number;
    qd_sa_9: number;
    qd_sa_10: number;
    qd_tr_5: number;
    qd_tr_6: number;
    qd_tr_7: number;
    qd_tr_8: number;
    qd_tr_9: number;
    qd_tr_10: number;
    qd_ex_5: number;
    qd_ex_6: number;
    qd_ex_7: number;
    qd_ex_8: number;
    qd_ex_9: number;
    qd_ex_10: number;

    constructor() {
        super();
        // this.type = Z_TUBEST_PURLIN;
        this.A = null;
        this.B = null;
        this.C = null;
        this.e = null;
        this.l = null;
        this.qt_sa_scr_5 = null;
        this.qt_sa_scr_6 = null;
        this.qt_sa_scr_7 = null;
        this.qt_sa_scr_8 = null;
        this.qt_sa_scr_9 = null;
        this.qt_sa_scr_10 = null;
        this.qt_sa_ccr_5 = null;
        this.qt_sa_ccr_6 = null;
        this.qt_sa_ccr_7 = null;
        this.qt_sa_ccr_8 = null;
        this.qt_sa_ccr_9 = null;
        this.qt_sa_ccr_10 = null;
        this.qt_tr_scr_5 = null;
        this.qt_tr_scr_6 = null;
        this.qt_tr_scr_7 = null;
        this.qt_tr_scr_8 = null;
        this.qt_tr_scr_9 = null;
        this.qt_tr_scr_10 = null;
        this.qt_tr_ccr_5 = null;
        this.qt_tr_ccr_6 = null;
        this.qt_tr_ccr_7 = null;
        this.qt_tr_ccr_8 = null;
        this.qt_tr_ccr_9 = null;
        this.qt_tr_ccr_10 = null;
        this.qt_ex_scr_5 = null;
        this.qt_ex_scr_6 = null;
        this.qt_ex_scr_7 = null;
        this.qt_ex_scr_8 = null;
        this.qt_ex_scr_9 = null;
        this.qt_ex_scr_10 = null;
        this.qt_ex_ccr_5 = null;
        this.qt_ex_ccr_6 = null;
        this.qt_ex_ccr_7 = null;
        this.qt_ex_ccr_8 = null;
        this.qt_ex_ccr_9 = null;
        this.qt_ex_ccr_10 = null;
        this.qd_sa_5 = null;
        this.qd_sa_6 = null;
        this.qd_sa_7 = null;
        this.qd_sa_8 = null;
        this.qd_sa_9 = null;
        this.qd_sa_10 = null;
        this.qd_tr_5 = null;
        this.qd_tr_6 = null;
        this.qd_tr_7 = null;
        this.qd_tr_8 = null;
        this.qd_tr_9 = null;
        this.qd_tr_10 = null;
        this.qd_ex_5 = null;
        this.qd_ex_6 = null;
        this.qd_ex_7 = null;
        this.qd_ex_8 = null;
        this.qd_ex_9 = null;
        this.qd_ex_10 = null;
    }
}


export class EaveStrutProfile extends SteelProfile {
    profile_type: number;
    A: number;
    B: number;
    e: number;
    Ez: number;
    ixy: number;
    Wx: number;

    constructor() {
        super();
        // this.type = SQUARED_PROFILE;
        this.A = null;
        this.B = null;
        this.e = null;
        this.Ez = null;
        this.ixy = null;
        this.Wx = null;
    }

}


export class SquaredProfile extends SteelProfile {
    A: number;
    B: number;
    e: number;
    l: number;

    constructor() {
        super();
        // this.type = SQUARED_PROFILE;
        this.A = null;
        this.B = null;
        this.e = null;
        this.l = null;
    }

}

export class RectangularProfile extends SteelProfile {
    A: number;
    B: number;
    e: number;
    l: number;

    constructor() {
        super();
        // this.type = RECTANGULAR_PROFILE;
        this.A = null;
        this.B = null;
        this.e = null;
        this.l = null;
    }
}


export class CintacPurlinProfile extends SteelProfile {
    A: number;
    B: number;
    C: number;
    e: number;
    l: number;
    qt_sa_scr_5: number;
    qt_sa_scr_6: number;
    qt_sa_scr_7: number;
    qt_sa_scr_8: number;
    qt_sa_scr_9: number;
    qt_sa_scr_10: number;
    qt_sa_ccr_5: number;
    qt_sa_ccr_6: number;
    qt_sa_ccr_7: number;
    qt_sa_ccr_8: number;
    qt_sa_ccr_9: number;
    qt_sa_ccr_10: number;
    qd_sa_5: number;
    qd_sa_6: number;
    qd_sa_7: number;
    qd_sa_8: number;
    qd_sa_9: number;
    qd_sa_10: number;

    constructor() {
        super();
        // this.type = CINTAC_PURLIN_PROFILE;
        this.A = null;
        this.B = null;
        this.C = null;
        this.e = null;
        this.l = null;
        this.qt_sa_scr_5 = null;
        this.qt_sa_scr_6 = null;
        this.qt_sa_scr_7 = null;
        this.qt_sa_scr_8 = null;
        this.qt_sa_scr_9 = null;
        this.qt_sa_scr_10 = null;
        this.qt_sa_ccr_5 = null;
        this.qt_sa_ccr_6 = null;
        this.qt_sa_ccr_7 = null;
        this.qt_sa_ccr_8 = null;
        this.qt_sa_ccr_9 = null;
        this.qt_sa_ccr_10 = null;
        this.qd_sa_5 = null;
        this.qd_sa_6 = null;
        this.qd_sa_7 = null;
        this.qd_sa_8 = null;
        this.qd_sa_9 = null;
        this.qd_sa_10 = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile.ts